import { Injectable, Inject } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Router } from "@angular/router";
import { IAuthService } from "../services/api/contracts/auth-service";
import { UserRoles } from '../models/enums/userRoles';

@Injectable({
  providedIn: "root",
})
export class RoleLandingGuardGuard implements CanActivate {
  userRoles = UserRoles
  constructor(
    private router: Router,
    @Inject("IAuthService") private authService: IAuthService
  ) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    let isAuthenticated = await this.authService.isAuthenticated();

    if (isAuthenticated) {
      let currentUser: any;
      try {
        currentUser = await this.authService.getCurrentProfile();
      } catch {
        await this.router.navigate(["/login"]);
        return false;
      }

      switch (currentUser.currentRole) {

        case this.userRoles.Admin:
        {
          if(currentUser?.organization.isParentOrganization)
            await this.router.navigate([
                "/admin/organizations",
            ]);
          else
            await this.router.navigate([
              "/admin/users/users",
            ]);
          break;
        }
        default:
          await this.router.navigate([
            "/guest/documents",
          ]);
          break;
      }
    }

    if (await this.authService.isAuthenticated()) return true;

    await this.router.navigate(["/login"]);

    return false;
  }
}
